import { gql } from '@apollo/client';

export const listCategories = gql`
  query listCategories($pagination: PaginationInput) {
    listCategories(pagination: $pagination) {
      id
      name {
        languageCode
        value
      }
      ordinal
      expand
      description {
        languageCode
        value
      }
      courses {
        id
        shortId
        name {
          languageCode
          value
        }
      }
      catalogs {
        id
        name {
          languageCode
          value
        }
      }
    }
  }
`;

export const listCatalogs = gql`
  query listCatalogs($pagination: PaginationInput, $filter: CatalogFilter) {
    listCatalogs(pagination: $pagination, filter: $filter) {
      id
      name {
        value
        languageCode
      }
    }
  }
`;
